<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    class="mode"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="商品選択"
    top="5vh"
    width="900px"
    :show-close="false"
    :visible.sync="dialogVisible"
    append-to-body
    @opened="opened"
    @close="close"
  >
    <vab-query-form-mode
      class="dpform noborder"
      :model="queryForm"
      :rules="rules"
      :enable-query-save="false"
      size="mini"
      label-position="left"
      label-width="140px"
      @search="onSearch"
    >
      <el-row :gutter="30">
        <el-col :span="8">
          <vab-input
            label="商品CD"
            label-width="100px"
            prop="itmcd"
            maxlength="4"
          />
        </el-col>
        <el-col :span="12">
          <vab-input
            label="商品名(半角ｶﾅ)"
            prop="itmnmk"
            maxlength="50"
            validate="halfKana"
          />
        </el-col>
        <el-col :span="24">
          <vab-checkbox-group
            ref="jtwrkkb"
            label-width="100px"
            label="受託作業区分"
            filter="entrustedWorkFlag"
            prop="jtwrkkbList"
            :disabled="localDisabled"
          />
        </el-col>
      </el-row>
    </vab-query-form-mode>
    <el-row class="m20">
      <el-col :span="24">
        <vab-table
          ref="table"
          api-url="/api/mitmbasp/query"
          :columns="columns"
          :custom-config="false"
          :multi-select="multiSelect"
          height="350"
          :init-params="queryForm"
          :query-params.sync="queryForm"
          :row-key="getRowKey"
          :enable-init="false"
          @selection-change="setSelectRows"
        />
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer flex_end">
      <div class="flex_start flex_center_align">
        <el-button class="cancel" @click="close">キャンセル</el-button>
        <!-- <div class="cancel" @click="close">キャンセル</div> -->
        <el-button type="primary" @click="save()">確定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import mixDialog from '@/utils/mixDialog'
  import { getEnumText } from '@/utils/index'
  export default {
    name: 'MitmbaspDialog',
    mixins: [mixDialog],
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        queryForm: {
          itmcd: null,
          itmnmk: null,
          jtwrkkbList: [],
        },
        localDisabled: false,
        columns: [
          {
            label: '商品CD',
            'min-width': 80,
            prop: 'itmcd',
          },
          {
            label: '商品名',
            'min-width': 120,
            prop: 'itmnm',
          },
          {
            label: '商品名(半角ｶﾅ)',
            'min-width': 120,
            prop: 'itmnmk',
          },
          {
            label: '受託作業区分',
            'min-width': 80,
            prop: 'jtwrkkb',
            formatter: (row, column, cellValue) => {
              return getEnumText(
                cellValue,
                this.$divisions.entrustedWorkFlagEnum
              )
            },
          },
        ],
      }
    },

    methods: {
      getRowKey(row) {
        return row.itmcd
      },
      setEntrustedWork() {
        if (this.queryForm.jtwrkkbList.length > 0) {
          this.localDisabled = true
        }
        this.$refs.jtwrkkb.setValue(this.queryForm.jtwrkkbList)
      },
    },
  }
</script>
